import React from 'react';
import { useLocation } from 'react-router-dom';

const WHATSAPP_NUMBER = '919152005251';
const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}`;

const WhatsAppFloat = () => {
  const location = useLocation();

  // Hide on admin pages
  if (location.pathname.startsWith('/admin')) {
    return null;
  }

  return (
    <a
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with us on WhatsApp"
      title="Chat on WhatsApp"
      className="fixed bottom-6 right-6 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg transition-transform duration-300 hover:scale-110 hover:shadow-xl focus:outline-none focus:ring-4 focus:ring-green-300"
    >
      <i className="fab fa-whatsapp text-3xl"></i>
      <span className="sr-only">Chat on WhatsApp</span>
    </a>
  );
};

export default WhatsAppFloat;
